import { faSpinnerThird } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useCurrentEditor } from '@tiptap/react';
import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { useStorage } from './useStorage';

function GrammarCheckerLoading() {
  const { editor } = useCurrentEditor();

  const loading = useStorage(s => s.loading);

  if (!editor || !loading) return null;

  return (
    <React.Fragment>
      <RenderOnEditor>
        <div className="absolute bottom-1 right-1">
          <FontAwesomeIcon icon={faSpinnerThird} className="animate-spin" />
        </div>
      </RenderOnEditor>
    </React.Fragment>
  );
}

export default React.memo(GrammarCheckerLoading);

function RenderOnEditor({ children }: { children: React.ReactNode }) {
  const { editor } = useCurrentEditor();
  const [element] = useState(() => document.createElement('div'));

  if (!editor) throw new Error('Editor not found');

  useEffect(() => {
    editor.view.dom.parentElement?.append(element);

    return () => {
      element.remove();
    };
  }, [editor, element]);

  return ReactDOM.createPortal(children, element) as any;
}
